import { Injectable } from '@angular/core';
import { sortBy } from 'lodash';

@Injectable()
export class LandingThemesService {
  /* tslint:disable */
  list = [
    {
      title: 'Travel',
      text: 'Adventure Travel',
      image: require('./assets/water-color.png'),
      thumbnail: require('./assets/travel.png'),
      sequence: 1,
      styles: [
        {
          title: 'Adventure Theme Park',
          image: require('./assets/album-styles/travel_adventure-theme-park_1.jpg'),
          sequence: 1,
        },
        {
          title: 'Classic Beach Summer',
          image: require('./assets/album-styles/travel_classic-beach-summer_1.jpg'),
          sequence: 2,
        },
        {
          title: 'Summer Pop',
          image: require('./assets/album-styles/travel_summer-pop_1.jpg'),
          sequence: 3,
        },
        {
          title: 'Vintage Travel',
          image: require('./assets/album-styles/travel_vintage-travel_1.jpg'),
          sequence: 4,
        },
      ]
    },
    {
      title: 'Baby',
      text: '',
      image: require('./assets/baby-girl-floral.png'),
      thumbnail: require('./assets/baby.png'),
      sequence: 2,
      styles: [
        {
          title: 'Baby Shower',
          image: require('./assets/album-styles/baby_baby-shower_1.jpg'),
          sequence: 1,
        },
        {
          title: 'Chalkboard Baby',
          image: require('./assets/album-styles/baby_chalkboard-baby_1.jpg'),
          sequence: 2,
        },
        {
          title: 'Pretty Pastel Floral',
          image: require('./assets/album-styles/baby_pretty-pastel-floral_1.jpg'),
          sequence: 3,
        },
        {
          title: 'Watercolor Floral',
          image: require('./assets/album-styles/baby_watercolor-floral_1.jpg'),
          sequence: 4,
        },
      ]
    },
    {
      title: 'Family',
      text: '',
      image: require('./assets/adventure-theme-park.png'),
      thumbnail: require('./assets/family.png'),
      sequence: 3,
      styles: [
        {
          title: 'Chalkboard Geometric',
          image: require('./assets/album-styles/family_chalkboard-geometric_1.jpg'),
          sequence: 1,
        },
        {
          title: 'Family Foliage',
          image: require('./assets/album-styles/family_foliage_1.jpg'),
          sequence: 2,
        },
        {
          title: 'Modern Vibrant',
          image: require('./assets/album-styles/family_modern-vibrant_1.jpg'),
          sequence: 3,
        },
        {
          title: 'Watercolor Musings',
          image: require('./assets/album-styles/family_watercolor-musings_1.jpg'),
          sequence: 4,
        },
      ]
    },
    {
      title: 'Kids',
      text: '',
      image: require('./assets/kids-birthday.png'),
      thumbnail: require('./assets/kids.png'),
      sequence: 4,
      styles: [
        {
          title: 'Birthday Doodles',
          image: require('./assets/album-styles/kids_birthday-doodles_1.jpg'),
          sequence: 1,
        },
        {
          title: 'Classic Sport',
          image: require('./assets/album-styles/kids_classic-sport_1.jpg'),
          sequence: 2,
        },
        {
          title: 'Halloween',
          image: require('./assets/album-styles/kids_halloween_1.jpg'),
          sequence: 3,
        },
        {
          title: 'Toybox',
          image: require('./assets/album-styles/kids_toybox_1.jpg'),
          sequence: 4,
        },
      ]
    },
    {
      title: 'Wedding',
      text: '',
      image: require('./assets/modern-white.png'),
      thumbnail: require('./assets/wedding.png'),
      sequence: 5,
      styles: [
        {
          title: 'Elegant Wedding',
          image: require('./assets/album-styles/wedding_elegant-wedding_1.jpg'),
          sequence: 1,
        },
        {
          title: 'Classic Damask',
          image: require('./assets/album-styles/wedding_classic-damask_1.jpg'),
          sequence: 2,
        },
        {
          title: 'Love',
          image: require('./assets/album-styles/wedding_love_1.jpg'),
          sequence: 3,
        },
        {
          title: 'Rustic Wedding',
          image: require('./assets/album-styles/wedding_rustic-wedding_1.jpg'),
          sequence: 4,
        },
      ]
    },
    {
      title: 'Seasonal',
      text: '',
      image: require('./assets/cruise.png'),
      thumbnail: require('./assets/seasonal.png'),
      sequence: 6,
      styles: [
        {
          title: 'Chic Christmas',
          image: require('./assets/album-styles/seasonal_chic-christmas_1.jpg'),
          sequence: 1,
        },
        {
          title: 'Fall Foliage',
          image: require('./assets/album-styles/seasonal_fall-foliage_1.jpg'),
          sequence: 2,
        },
        {
          title: 'Summer Pop',
          image: require('./assets/album-styles/seasonal_summer-pop_1.jpg'),
          sequence: 3,
        },
        {
          title: 'Winter Magic',
          image: require('./assets/album-styles/seasonal_winter-magic_1.jpg'),
          sequence: 4,
        },
      ]
    },
  ];
  /* tslint:enable */

  get() {
    return sortBy(this.list, (item) => item.sequence );
  }
}
